import { render, staticRenderFns } from "./Sick.vue?vue&type=template&id=0e39b308&scoped=true"
import script from "./Sick.vue?vue&type=script&lang=js"
export * from "./Sick.vue?vue&type=script&lang=js"
import style0 from "./Sick.vue?vue&type=style&index=0&id=0e39b308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e39b308",
  null
  
)

export default component.exports